import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { getFlag } from '../../../config/flags';
import { isNullOrEmpty } from '../../../utils/core';
import Modal from '../../generic/Modal';
import Flow from '../../flow';
import Config from '../config';

const MapElementConfiguration = ({
    config,
    isConfigActive,
    tenantId,
    authenticationToken,
    configPanelComponent,
    configPanelProps,
    container,
}) => getFlag('canvas') ? 
    (
        !isNullOrEmpty(config && config.flow) ?
            (
                // Render System Flow (deprecated)
                <Modal
                    renderBody={() => {
                        const inputs = (config && config.inputs) || [];

                        if (tenantId && authenticationToken) {
                            inputs.push({ 'Input TenantId': tenantId });
                            inputs.push({ 'Input AuthenticationToken': authenticationToken });
                        }

                        return (
                            <Flow
                                tenantId={manywho.settings.global('adminTenantId')}
                                flowName={config && config.flow}
                                inputs={config && config.inputs}
                                options={config && config.options}
                                component="main"
                                callbacks={config && config.callbacks}
                            />
                        );
                    }}
                    show={Boolean(config || isConfigActive)}
                    dialogClassName="modal-large"
                    container={container}
                />
            ) : 
            (configPanelComponent && configPanelProps) ?
                // Render React component 
                React.createElement(configPanelComponent, { ...configPanelProps, container }) :
                null
    ) :
    (
        <CSSTransitionGroup transitionName="config" transitionAppearTimeout={500} transitionLeaveTimeout={300} transitionEnterTimeout={500}>
            {
                config || isConfigActive ? (
                    <Config
                        manywhoTenantId={tenantId}
                        authenticationToken={authenticationToken}
                        callbacks={config && config.callbacks}
                        flow={config && config.flow}
                        inputs={config && config.inputs}
                        options={config && config.options}
                        key={config && config.mapElementId}
                        tenantId={manywho.settings.global('adminTenantId')}
                        rootComponent={configPanelComponent}
                        rootComponentProps={configPanelProps}
                    />
                ) : null
            }
        </CSSTransitionGroup>
    );

export default MapElementConfiguration;
